(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealSelector = '#MainContent .section, #MainContent .hero, #MainContent .trust, #MainContent .support-cards';

  function revealEverything() {
    document.querySelectorAll('.motion-reveal').forEach(function (element) {
      element.classList.add('is-visible');
    });
  }

  function initialiseMotion(root) {
    if (reducedMotion.matches) {
      document.documentElement.classList.remove('motion-ready');
      return;
    }

    var scope = root || document;
    var revealElements = scope.querySelectorAll(revealSelector);
    if (!('IntersectionObserver' in window)) {
      revealElements.forEach(function (element) {
        element.classList.add('motion-reveal', 'is-visible');
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -7% 0px' });

    revealElements.forEach(function (element) {
      if (element.dataset.motionBound === 'true') return;
      element.dataset.motionBound = 'true';
      element.classList.add('motion-reveal');
      observer.observe(element);
    });

  }

  document.addEventListener('DOMContentLoaded', function () {
    initialiseMotion(document);

    document.addEventListener('pointerdown', function (event) {
      if (reducedMotion.matches) return;
      var target = event.target.closest('.button, .recommendations__tabs button, .utility-link, .card');
      if (!target || target.hasAttribute('disabled')) return;
      target.classList.remove('motion-click');
      window.requestAnimationFrame(function () {
        target.classList.add('motion-click');
      });
    });

    document.addEventListener('animationend', function (event) {
      if (event.animationName === 'motion-press') event.target.classList.remove('motion-click');
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialiseMotion(event.target);
  });

  reducedMotion.addEventListener('change', function (event) {
    if (event.matches) {
      document.documentElement.classList.remove('motion-ready');
      revealEverything();
    }
  });
}());
